module.exports = __webpack_public_path__ + "static/media/vd-bg.85daee02.jpg";